import React from "react";
import "./App.css";
import Counter from "./components/Counter";
// import CounterHooks from "./components/CounterHooks";

function App() {
	return (
		<div className="App">
			<Counter />
			{/* <CounterHooks /> */}
		</div>
	);
}

export default App;
